module.exports = __webpack_public_path__ + "img/top-btm.ab940354.png";